import api from "../Api";

// helper: build auth headers from stored token
const getAuthHeaders = () => {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token") || null;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// جلب جميع منتجات الإدارة — يدعم params اختيارية ويضم هدر المصادقة
export const getAdminProducts = async (params = {}) => {
  try {
    const headers = {
      ...getAuthHeaders(),
    };
    const response = await api.get("/admin/get-all-products", { params, headers });
    return response.data;
  } catch (error) {
    console.error("Error fetching admin products:", error);
    throw error;
  }
};

// حفظ/إضافة منتجات بالجملة — يقبل payload (مثلاً { products: [...] }) أو أي جسم JSON آخر
// export const saveProducts = async (payload = {}, params = {}) => {
//   try {
//     // ✅ 1) نظّف الـ payload: احذف currencies لو فاضية
//     const cleanedPayload = {
//       ...payload,
//       products: (payload.products || []).map((p) => {
//         const next = { ...p };

//         const hasCurrencies =
//           Array.isArray(next.currencies) && next.currencies.length > 0;

//         if (!hasCurrencies) {
//           delete next.currencies; // ✅ مهم: شيل المفتاح نفسه
//           return next;
//         }

//         // ✅ لو موجودة: فلترة أي صف ناقص (اختياري)
//         next.currencies = next.currencies.filter(
//           (c) => c && c.country_id && c.price !== "" && c.price != null
//         );

//         // لو بعد الفلترة بقت فاضية، شيلها برضه
//         if (next.currencies.length === 0) delete next.currencies;

//         return next;
//       }),
//     };

//     const headers = {
//       "Content-Type": "application/json",
//       ...getAuthHeaders(),
//     };

//     const mergedParams = {
//       api_password: "EcommercApp@2026_$",
//       ...params,
//     };

//     const response = await api.post(
//       "/admin/save-products",
//       cleanedPayload,
//       { headers, params: mergedParams }
//     );

//     return response.data;
//   } catch (error) {
//     console.error("Error saving products:", error);
//     throw error;
//   }
// };
export const saveProducts = async (payload = {}, params = {}) => {
  try {
    const mergedParams = {
      api_password: "EcommercApp@2026_$",
      ...params,
    };

    const isFormData =
      typeof FormData !== "undefined" && payload instanceof FormData;

    // ✅ لو FormData (فيه صور)
    if (isFormData) {
      const headers = {
        ...getAuthHeaders(),
        // ⚠️ سيب Axios يحدد multipart boundary لوحده
      };

      const response = await api.post("/admin/save-products", payload, {
        headers,
        params: mergedParams,
      });

      return response.data;
    }

    // ✅ لو JSON عادي (مفيش صور)
    const cleanedPayload = {
      ...payload,
      products: (payload.products || []).map((p) => {
        const next = { ...p };

        const hasCurrencies =
          Array.isArray(next.currencies) && next.currencies.length > 0;

        if (!hasCurrencies) {
          delete next.currencies;
          return next;
        }

        next.currencies = next.currencies.filter(
          (c) => c && c.country_id && c.price !== "" && c.price != null
        );

        if (next.currencies.length === 0) delete next.currencies;

        return next;
      }),
    };

    const headers = {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    };

    const response = await api.post("/admin/save-products", cleanedPayload, {
      headers,
      params: mergedParams,
    });

    return response.data;
  } catch (error) {
      console.log("STATUS:", error?.response?.status);
  console.log("DATA:", error?.response?.data);
    // ✅ هات رسالة السيرفر (مهمة جدًا مع 422)
    console.error("Error saving products:", {
      status: error?.response?.status,
      data: error?.response?.data,
    });
    throw error;
  }
};


// تحديث منتج عبر form-data (id يجب أن يكون في formData كـ product_id أو id)
export const updateProduct = async (formData) => {
  // احصل على id من formData
  const id =
    typeof FormData !== "undefined" && formData instanceof FormData
      ? formData.get("product_id") || formData.get("id") || formData.get("productId")
      : null;

  if (!id) throw new Error("product_id or id is required to update product.");

  // normalize boolean-like fields to '1'/'0'
  if (typeof FormData !== "undefined" && formData instanceof FormData) {
    ["status", "sale", "retrun_status"].forEach((field) => {
      const v = formData.get(field);
      if (v !== null) {
        if (v === true || v === "true" || v === "1" || v === 1 || v === "active") {
          formData.set(field, "1");
        } else {
          formData.set(field, "0");
        }
      }
    });
    // normalize numeric fields if present (optional)
    const numFields = ["quantity", "discount", "price", "price_after_discount"];
    numFields.forEach((f) => {
      const v = formData.get(f);
      if (v !== null && v !== "") {
        const n = Number(v);
        if (!Number.isNaN(n)) formData.set(f, String(n));
      }
    });
  }

  const headers = {
    "Content-Type": "multipart/form-data",
    ...getAuthHeaders(),
  };
  const params = {
    api_password: "EcommercApp@2026_$",
  };

  try {
    const response = await api.post(`/admin/update-product/${id}`, formData, { headers, params });
    return response.data;
  } catch (error) {
    console.error("Error updating product:", error);
    // extract and surface validation messages if any
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// حذف منتج بواسطة id — يستخدم api_password ويضم هدر المصادقة
export const deleteProduct = async (id, params = {}) => {
  if (!id) throw new Error("product id is required to delete product.");

  const headers = {
    ...getAuthHeaders(),
  };
  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };

  try {
    const response = await api.get(`/admin/delete-product/${id}`, { headers, params: mergedParams });
    return response.data;
  } catch (error) {
    console.error("Error deleting product:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

// جلب تفاصيل منتج واحد حسب id — يضيف api_password و هدر المصادقة
export const getProduct = async (id, params = {}) => {
  if (!id) throw new Error("product id is required to get product.");
  const headers = {
    ...getAuthHeaders(),
  };
  const mergedParams = {
    api_password: "EcommercApp@2026_$",
    ...params,
  };
  try {
    const response = await api.get(`/admin/get-product/${id}`, { headers, params: mergedParams });
    return response.data;
  } catch (error) {
    console.error("Error fetching product:", error);
    const serverData = error?.response?.data;
    if (serverData) {
      const msgs = [];
      if (serverData.message) msgs.push(serverData.message);
      if (serverData.errors && typeof serverData.errors === "object") {
        Object.values(serverData.errors).forEach((v) => {
          if (Array.isArray(v)) msgs.push(...v);
          else msgs.push(v);
        });
      }
      if (msgs.length) {
        const err = new Error(msgs.join(" | "));
        err.original = error;
        throw err;
      }
    }
    throw error;
  }
};

